import { createRoot } from "react-dom/client";
import "./reset.css";
import "./fonts.css";
import "./variables.css";
import "./components.scss";
import "./index.scss";
import "./analytics";
import App from "./App";

const container = document.getElementById("root");
console.log("January 2026 build");
// @ts-ignore
const root = createRoot(container);
root.render(<App />);
